import React from 'react';
import { Skeleton as MuiSkeleton } from '@mui/material';
import { SkeletonProps } from './model';
export type { SkeletonProps } from './model';

export const Skeleton: React.FC<SkeletonProps> = (props) => {
  return <MuiSkeleton animation="wave" {...props} />;
};
